import { render, staticRenderFns } from "./AdminDeliveriesEditScreen.vue?vue&type=template&id=615da1af&scoped=true&"
import script from "./AdminDeliveriesEditScreen.vue?vue&type=script&lang=js&"
export * from "./AdminDeliveriesEditScreen.vue?vue&type=script&lang=js&"
import style0 from "./AdminDeliveriesEditScreen.vue?vue&type=style&index=0&id=615da1af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615da1af",
  null
  
)

export default component.exports